import { useState, type FormEvent } from 'react'
import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import AlternateEmailRounded from '@mui/icons-material/AlternateEmailRounded'
import LockRounded from '@mui/icons-material/LockRounded'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'

export function LoginPage() {
  const auth = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  if (auth.authenticated) return <Navigate to="/" replace />

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await auth.login(username, password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível autenticar.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, background: 'radial-gradient(circle at 10% 10%,rgba(79,70,229,.18),transparent 35%),radial-gradient(circle at 90% 80%,rgba(6,182,212,.16),transparent 40%)' }}>
      <Card sx={{ width: '100%', maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
          <Stack alignItems="center" textAlign="center">
            <Stack sx={{ width: 58, height: 58, borderRadius: 3, display: 'grid', placeItems: 'center', color: 'white', background: 'linear-gradient(135deg,#4f46e5,#06b6d4)', mb: 2 }}>
              <AlternateEmailRounded fontSize="large" />
            </Stack>
            <Typography variant="h4">EmailServer</Typography>
            <Typography color="text.secondary" mt={1} mb={4}>Acesse o painel seguro da sua organização.</Typography>
          </Stack>
          <Stack component="form" onSubmit={handleSubmit} gap={2}>
            <TextField label="Usuário ou e-mail" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoFocus required fullWidth />
            <TextField label="Senha" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required fullWidth />
            {error && <Alert severity="error">{error}</Alert>}
            <Button type="submit" fullWidth size="large" variant="contained" startIcon={<LockRounded />} loading={submitting}>
              Entrar
            </Button>
          </Stack>
          <Typography variant="caption" color="text.secondary" display="block" textAlign="center" mt={3}>
            Autenticação protegida por OAuth 2.0 / OpenID Connect
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
